<div class="tw-flex tw-h-full tw-flex-col">
    <app-stock-management-tabs class="tw-shrink-0" (tabIndexChange)="changeTab($event)" />

    <div class="filter-chip-container tw-shrink-0 tw-p-4">
        <mat-chip-listbox #chipList (change)="onFilterStatusChange($event.value)" [value]="currentStockLocationId()" required="true" [hideSingleSelectionIndicator]="true">
            @for(stockLocation of stockLocations; track stockLocation.id) {
                <mat-chip-option [value]="stockLocation.id" [selected]="stockLocation.id === currentStockLocationId()" class="custom-chip tw-px-2 tw-py-0.5 tw-rounded-full tw-font-bold">
                    {{ stockLocation.name }}
                </mat-chip-option>
            }
        </mat-chip-listbox>
    </div>

    <app-grid-server-side
        #appGridComponent
        class="tw-block tw-min-h-0 tw-flex-1"
        [fixedButtons]="fixedButtons"
        [cacheBlockSize]="query.per_page"
        [datasource]="datasource"
        [tableData]="tableData[0]"
        feature="stock"
    />
</div>

<app-barcode [hideButton]="true" (onSubmitBarcode)="onBarcodeScanned($event)"></app-barcode>
